import { OrderType } from 'types/checkout'
import { FirebaseDocRefType, FirebaseDocumentDataType, FirebaseSnapshotType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { fetchStoreShippingsAction } from 'reducks/storeShipping/actions'
import { StoreShippingType } from 'types/storeShipping'

const fetchStoreShippingsFromOrders = (orders: OrderType[], storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    const promises = []

    for (let i = 0; i < orders.length; i = (i + 1) | 0) {
      const order = orders[i]
      promises.push(
        storeRef
          .collection('store_shippings')
          .where('scheduled_delivery_date', '==', order.date)
          .where('user_id', '==', order.user_id)
          .get()
          .then((snapshots: FirebaseDocumentDataType) => {
            const storeShippings: StoreShippingType[] = []
            snapshots.forEach((snapshot: FirebaseSnapshotType) => {
              const data = snapshot.data() as StoreShippingType
              storeShippings.push(data)
            })
            return storeShippings
          })
      )
    }

    const storeShippings = await Promise.all(promises)
      .then((result) => {
        const _storeShippings: StoreShippingType[] = []
        for (let i = 0; i < result.length; i = (i + 1) | 0) {
          const storeShippingList = result[i]
          for (let j = 0; j < storeShippingList.length; j = (j + 1) | 0) {
            const storeShipping = storeShippingList[j]
            if (
              _storeShippings.some((_storeShipping) => _storeShipping.shipping_number === storeShipping.shipping_number)
            )
              continue
            _storeShippings.push(storeShipping)
          }
        }
        return _storeShippings
      })
      .catch((error: unknown) => {
        console.error(error)
        return []
      })

    dispatch(fetchStoreShippingsAction(storeShippings))
  }
}

export default fetchStoreShippingsFromOrders
